import { useEffect, useMemo, useState } from "react";
import { Clock } from "lucide-react";
import ProductCard from "@/components/ProductCard";
import { useCart } from "@/context/CartContext";
import { useLanguage } from "@/context/LanguageContext";

const pad = (n) => String(n).padStart(2, "0");

export default function Deals() {
  const { products } = useCart();
  const { t } = useLanguage();
  const [left, setLeft] = useState("");

  const deals = useMemo(
    () => products.filter((p) => p.badge === "Best Seller").slice(0, 12),
    [products]
  );

  useEffect(() => {
    const tick = () => {
      const now = new Date();
      const end = new Date(now);
      end.setHours(23, 59, 59, 999);
      const diff = Math.max(0, end - now);
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      setLeft(`${pad(h)}:${pad(m)}:${pad(s)}`);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  if (deals.length === 0) return null;

  return (
    <section id="deals" data-testid="deals-section" className="px-4 py-4 lg:px-8">
      <div className="mx-auto max-w-7xl rounded-lg border border-line bg-white p-5">
        <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
          <div>
            <h2 className="text-lg font-bold text-brandink" data-testid="deals-title">{t("deal_title")}</h2>
            <p className="text-xs text-muted">{t("deal_sub")}</p>
          </div>
          <div className="flex items-center gap-2 rounded-md bg-brandink px-3 py-2" data-testid="deals-countdown">
            <Clock className="h-4 w-4 text-brand" />
            <span className="text-[11px] font-medium text-white/80">{t("deal_ends")}</span>
            <span className="font-mono text-sm font-bold tracking-widest text-brand" dir="ltr">{left}</span>
          </div>
        </div>
        <div className="no-scrollbar flex gap-3 overflow-x-auto pb-2">
          {deals.map((p) => (
            <div key={p.id} className="w-44 shrink-0 sm:w-52" data-testid={`deal-card-${p.id}`}>
              <ProductCard product={p} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
